function initializeChoixBox(sectionId) {
  const sectionElement = document.getElementById(sectionId);
  if (!sectionElement || sectionElement.dataset.initialized) {
    return;
  }
  sectionElement.dataset.initialized = 'true';

  const cards = sectionElement.querySelectorAll('.box-card');
  const ctaButton = sectionElement.querySelector('.btn-principal');
  const ctaWrapper = sectionElement.querySelector('.choix-box-cta-wrapper'); 
  
  if (cards.length === 0 || !ctaButton || !ctaWrapper) {
    return;
  }
  
  const textCta = ctaButton.textContent.trim();
  const textReturn = "Choisir ma Box";
  let isReturnMode = false;

  const updateState = () => {
    const checkedInput = sectionElement.querySelector('.card-radio-input:checked');
    cards.forEach(card => card.classList.remove('is-selected'));
    if (checkedInput) {
      const selectedCard = checkedInput.closest('.box-card');
      selectedCard.classList.add('is-selected');
      ctaButton.href = selectedCard.dataset.link;
      ctaButton.classList.remove('is-disabled');
    } else {
      ctaButton.href = '#';
      ctaButton.classList.add('is-disabled');
    }
  };

  // AJOUT : La fonction qui gère le défilement automatique
  const scrollToButtonIfNeeded = () => {
    const wrapperRect = ctaWrapper.getBoundingClientRect();
    // Si le bas du bouton est sous l'écran OU si le haut du bouton est au-dessus de l'écran
    if (wrapperRect.bottom > window.innerHeight || wrapperRect.top < 0) {
      ctaWrapper.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  cards.forEach(card => {
    card.addEventListener('click', () => {
      const radio = card.querySelector('.card-radio-input');
      if (radio) {
        radio.checked = true;
        updateState();
        // APPEL de la fonction de défilement juste après la sélection
        scrollToButtonIfNeeded();
      }
    });
  });
  
  const stickyObserver = new IntersectionObserver(
    ([entry]) => {
      const isScrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      ctaButton.classList.toggle('is-sticky', isScrolledPast);
    },
    { threshold: 0 }
  );
  stickyObserver.observe(ctaWrapper);
  
  const sectionObserver = new IntersectionObserver(
    ([entry]) => {
      const isAboveViewport = entry.boundingClientRect.bottom < 0;
      if (!entry.isIntersecting && isAboveViewport) {
        isReturnMode = true;
        ctaButton.textContent = textReturn;
      } else {
        isReturnMode = false;
        ctaButton.textContent = textCta;
      }
    },
    { rootMargin: "0px 0px -100% 0px" }
  );
  sectionObserver.observe(sectionElement);

  ctaButton.addEventListener('click', (event) => {
    if (isReturnMode) {
      event.preventDefault();
      sectionElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  updateState();
}